import Button from '@/common/components/Button'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { FormTransformers } from '@/common/utils/formTransformers'
import { useMaintenanceDirectiveDiagnosticEntryRegress } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/directive/diagnosticEntries/useMaintenanceDirectiveDiagnosticEntryRegress'
import { useForwardingTabContext } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/useForwardingTabContext'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

const DirectiveEntryDiagnosticEntriesRegress = () => {
  const { forwarding } = useForwardingTabContext()

  const { id } = useParams()

  const queryClient = useQueryClient()

  const [messages, setMessages] = useState<string[] | boolean>(false)

  const { mutate: regress, isPending: regressIsPending } = useMaintenanceDirectiveDiagnosticEntryRegress({
    directiveEntryId: forwarding?.directive_entry?.id,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['maintenanceForwarding', forwarding.id],
        })

        queryClient.invalidateQueries({
          queryKey: ['maintenanceWorkflow', id],
        })
      },
      onError: (error) => {
        FormTransformers.errorsTransformer({
          setMessages,
        })(error)
      },
    },
  })

  return (
    <>
      <Button
        variant="yellow-black"
        operationKlassToCheckPermission="Client::Maintenance::Directive::DiagnosticEntries::Regress"
        onClick={() => regress()}
        isLoading={regressIsPending}
      >
        Solicitar revisão
      </Button>

      <ModalMessageSimple messages={messages} setMessages={setMessages} isError />
    </>
  )
}

export default DirectiveEntryDiagnosticEntriesRegress
